import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from '@/application/auth/config/msalConfig'

// Shared MSAL instance: initialized once for the entire app
export const msalInstance = new PublicClientApplication(msalConfig)
